const HIDDEN_CLASS = 'section__item--hidden';

const sections = document.querySelectorAll<HTMLElement>('.section__container[data-limit="true"]');

sections.forEach((section) => {
    const items = Array.from(section.querySelectorAll<HTMLElement>(".section__item"));
    const btn = section.querySelector<HTMLButtonElement>(".show-more__button");
    if (!btn) {
        return;
    }

    btn.addEventListener("click", (e) => {
        e.preventDefault();
        items.forEach((item) => item.classList.remove(HIDDEN_CLASS));

        // accessibility: update aria-expanded and focus first newly revealed link/button
        btn.setAttribute("aria-expanded", "true");

        const container = btn.closest<HTMLElement>(".show-more");
        if (container) {
            container.hidden = true;
        }
    });
});